import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=dad29ade&scoped=true&"
import script from "./Remark.vue?vue&type=script&lang=js&"
export * from "./Remark.vue?vue&type=script&lang=js&"
import style0 from "./Remark.vue?vue&type=style&index=0&id=dad29ade&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=dad29ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad29ade",
  null
  
)

export default component.exports